import { render } from "./TestTitle.vue?vue&type=template&id=f0667044&scoped=true"
import script from "./TestTitle.vue?vue&type=script&lang=js"
export * from "./TestTitle.vue?vue&type=script&lang=js"

import "./TestTitle.vue?vue&type=style&index=0&id=f0667044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0667044"]])

export default __exports__